export default {
  getActionLog: {
    method: 'get',
    url: 'admin-log/list',
    permission: {
      name: "获取操作日志列表",
      page: "logAction",
    }
  },
  getLoginLog: {
    method: 'get',
    url: 'admin-login-log/list',
    permission: {
      name: "获取登录日志列表",
      page: "logLogin",
    }
  },
}
